<template>
  <div class="page-content">
    <h1 class="page-title">{{ $locale("sideMenu.cinemaWebsite.rentalSpace") }}</h1>
    <el-form
      class="egl-elm egl-detail"
      :model="websiteGuideSettingInfo"
      ref="detailForm"
      label-position="top"
    >
      <el-row>
        <el-col :span="10">
          <el-form-item
            :label="$locale('cinemaWebsite.companyInfo.formItem.self-definedColumnTitle')"
            prop="rentalSpaceTitle"
          >
            <el-input
              v-model="websiteGuideSettingInfo.rentalSpaceTitle"/>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item
            :label="$locale('cinemaWebsite.companyInfo.formItem.customColumnPortrait')"
            prop="rentalSpaceUrl"
            class="upload"
          >
            <UploadContainer
              :type="'B'"
              :imageList="[websiteGuideSettingInfo.rentalSpaceUrl]"
              @onSuccess="({response}) => uploadSuccess(response)"
              @onDelete="deleteImg"
            ></UploadContainer>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <el-row>
      <el-col :span="24" style="margin-top:20px;text-indent: 550px;">
        <el-button style="width: 200px;" class="egl-btn-yellow" @click="save_fn">{{ $locale("global.confirm2") }}</el-button>
      </el-col>
    </el-row>
  </div>
</template>
<script>
  import UploadContainer from "@/components/common/UploadContainer";
  import { getWebsiteSettingGuideService, updateWebsiteSettingGuideService } from "@/helpers/service/api/cinemaWebsite";
  import countDownAlert from "@/utils/countDownAlert";
  export default {
    data() {
      return {
        websiteGuideSettingInfo: {
          rentalSpaceTitle: "",
          rentalSpaceUrl: "",
        }
      }
    },
    created() {
      this.getList();
    },
    methods: {
      uploadSuccess(res) {
        if (res.success) {
          this.websiteGuideSettingInfo = { ...this.websiteGuideSettingInfo, rentalSpaceUrl: res.data };
        }
      },
      deleteImg() {
        this.websiteGuideSettingInfo = { ...this.websiteGuideSettingInfo, rentalSpaceUrl: "" };
      },
      getList() {
        getWebsiteSettingGuideService({
          cinemaId: window.localStorage.getItem("cinemaId")
        }).then(res => {
          this.websiteGuideSettingInfo = res.data;
        });
      },
      requestScuessFn(res, countDownText) {
        if (!res.success) { return; }
        countDownAlert({
          content: countDownText
        });
      },
      save_fn() {
        const requestParam = {
          ...this.websiteGuideSettingInfo,
          cinemaId: window.localStorage.getItem("cinemaId"),
        };
        updateWebsiteSettingGuideService(requestParam).then(res => {
          this.requestScuessFn(res, this.$locale("global.updateSuccessfully"));
        });
      }
    },
    components: {
      UploadContainer
    }
  }
</script>